<template>
  <div class="search-container">
    <BannerSearch> </BannerSearch>
    <div class="bg">
      <div class="inner-box" v-if="!loading">

        <div class="top-alert">
          <div class="txt">
            <div class="num" v-if="articleList.length != 0">{{ articleList.length }}</div>
            {{ articleList.length != 0 ? articleList.length == 1 ? $t('m.search.one') : $t('m.search.res') :
              $t('m.search.emply') }}
          </div>
        </div>
        <div class="search-res" v-for="item, index in articleList" :key="index">
          <div class="title" @click="$router.push('/article?' + 'id=' + item.id)" v-html="highlightKeywords(item.title)">
          </div>
          <div class="excerpt" v-html="highlightKeywords(item.excerpt)">
          </div>
          <div class="time">{{ item.create_time }}</div>
        </div>
      </div>
      <Loading v-if="loading" :bgColor="''"></Loading>
    </div>
  </div>
</template>
<script>
import BannerSearch from "../components/BannerSearch.vue";
import Featured from "../components/Featured.vue";
import Loading from "../components/Loading.vue";
export default {
  components: { BannerSearch, Featured, Loading },
  data() {
    return {
      articleList: [],
      searchRes: [],
      search: "",
      loading: true
    }
  },
  watch: {
    '$route.query.search': function () {
      // 只要categoryId的值发生变化,这个方法就会被调用
      this.search = this.$route.query.search
      // this.searchMethod()
      this.loading = true
      if (this.search != '') {
        this.getData()
      } else {
        this.articleList = []
        this.loading = false
      }

    }

  },
  mounted() {
    this.search = this.$route.query.search
    var count = 0
    let timer = setInterval(() => {
      count++
      if (count >= 50) {
        clearInterval(timer)
      }
      if (this.$store.state.class != '') {
        this.getData()

        // this.searchMethod()
        clearInterval(timer)
      }
    }, 200);

  },
  computed: {
    filteredArray() {
      // 过滤数组，只保留包含关键词的项
      return this.articleList.filter(item => item.title.rendered.toLowerCase().includes(this.search.toLowerCase()));
    },
  },
  methods: {
    highlightKeywords(item) {
      console.log(item);

      // 删除所有的 <a> 标签
      var withoutLinks = item.rendered.replace(/<a\b[^>]*>(.*?)<\/a>/gi, '');

      // 将关键词高亮显示
      var escapedSearch = this.escapeRegExp(this.search);
      var regex = new RegExp('(' + escapedSearch + ')', 'gi');
      var highlightedText = withoutLinks.replace(regex, '<span class="highlight">$1</span>');

      return highlightedText;
    },

    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    searchMethod() {
      console.log(this.$route.query.search);

      this.searchRes = []
      this.articleList.map((item) => {
        if (item.title.rendered.toLowerCase().indexOf(this.search.toLowerCase()) != -1) {
          this.searchRes.push(item);
        }
      });
    },
    dateTrans(date) {
      let _date = new Date(parseInt(date));//13位
      // let _date = new Date(parseInt(date) * 1000);//10位
      let y = _date.getFullYear();
      let m = _date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      let d = _date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = _date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let minute = _date.getMinutes();
      let second = _date.getSeconds();
      minute = minute < 10 ? ('0' + minute) : minute; second = second < 10 ? ('0' + second) : second;
      // let dates = y + '-' + m + '-' + d;//年月日
      let dates = y + '-' + m + '-' + d;//年月日时分秒
      return dates;
    },
    getData() {
      if (this.search != '') {
        this.$axios({
          method: 'get',
          url: this.$backend.wpHost + '/posts?_embed&_fields=id,title,excerpt,content&_json_encode_partial_output=content&per_page=99&_content_limit=2&search=' + this.$route.query.search
        }).then(res => {
          console.log(res);
          this.articleList = res.data
          this.loading = false
        }).catch(err => {
          console.log(err);
          this.loading = false
        });

      } else {
        this.loading = false
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.title::v-deep .highlight {
  color: #ffc000;

}

.excerpt::v-deep .highlight {
  color: #ffc000;

}

.excerpt::v-deep p {
  line-height: 1.7;
  font-size: 15px;
  font-family: 'Nunito-Bold', HYZhengYuan-65W, Microsoft YaHei, sans-serif;
  color: #3f4141;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

@import "../assets/scss/search.scss";
</style>